import type React from "react";

import { Info } from "lucide-react";

import type { ScoreMethodology } from "../../types/scoreExplanation";

interface ScoreMethodologyBlockProps {
  readonly methodology?: ScoreMethodology | null;
}

/** Displays the report-supplied plain-language methodology once for a score group. */
export function ScoreMethodologyBlock({
  methodology,
}: ScoreMethodologyBlockProps): React.ReactElement | null {
  if (!methodology) return null;
  return (
    <section
      className="mt-4 rounded-xl bg-surface-container-low p-4"
      aria-labelledby="score-methodology-title"
    >
      <div className="flex items-center gap-2">
        <Info className="h-4 w-4 text-primary" />
        <h3 id="score-methodology-title" className="font-semibold text-on-surface">
          {methodology.title}
        </h3>
      </div>
      <p className="mt-2 text-sm text-on-surface-variant">{methodology.summary}</p>
      <ul className="mt-2 list-disc pl-5 text-sm text-on-surface-variant">
        {methodology.drivers.map((driver) => (
          <li key={driver}>{driver}</li>
        ))}
      </ul>
      {methodology.caveat && (
        <p className="mt-2 text-sm italic text-on-surface-variant">{methodology.caveat}</p>
      )}
    </section>
  );
}
